import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'

import Provider from 'model/provider/provider'
import FacilityProfileV2 from 'model/facilities/facilityProfileV2'

import verified_icon from 'assets/verified_icon.svg'
import { getStandardDateFormat } from 'utils/helpers/dateHelper'

import { VerifiedWrap } from './styled'

const EntityVerified = ({ entity, showVerifier = false, dataTest }) => {
  const { confirmed, confirmed_at, confirmed_by } = entity

  if (!confirmed) return false

  const title = `Verified at ${getStandardDateFormat(confirmed_at)} by ${
    confirmed_by?.full_name || 'Unknown'
  }`
  const text = `${getStandardDateFormat(confirmed_at)} ${
    showVerifier ? `by ${confirmed_by?.full_name || 'Unknown'}` : ''
  }`

  return (
    <Tooltip placement="topLeft" title={title}>
      <VerifiedWrap data-test={dataTest}>
        <img
          key={`verified_${entity.id}`}
          src={verified_icon}
          alt="Verified"
          style={{ maxHeight: 20, marginRight: 8 }}
        />
        {text}
      </VerifiedWrap>
    </Tooltip>
  )
}

EntityVerified.propTypes = {
  entity: PropTypes.oneOfType([
    PropTypes.instanceOf(Provider),
    PropTypes.instanceOf(FacilityProfileV2)
  ]).isRequired,
  showVerifier: PropTypes.bool
}

export default EntityVerified
